/* the kinds of project nodes */

export enum ProjectElementType {
  Simulation,
  SimulationGroup,
  Manifest,
  Inputs,
  Results,
  Snapshots,
  Dimension,
  Blob,
  Root,
  LineSimResult,
  KPI,
  KPIX,
  KPITable,
  LocomotiveModel,
  OperationalMeasures,
  LocoMotiveModelResult,
  LineSimResultCalculated,
  CorridorGroup,
  BatchGroup,
  CorridorBatch,
  BatchSimResult,
  RegressionResult,
  BatchSummaries,
  BatchMeasure,
  UserCommands,
  UserCommandsResult,
  DiamondCrossings,
  DiamondCrossingsResult,
  Property,
  None
}
